import React from 'react';
import { StyleSheet, View } from 'react-native';

import PersonSearch from '@organisms/PersonSearch';
import useStartOrGetConversation from '@queries/conversations';
import { withAuthGate } from '@sunrise-ui/composites';
import {
  useAuthStore,
  useDynamicStyles,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import { router } from 'expo-router';

function NewMessageScreen() {
  const styles = useDynamicStyles(createStyles);
  const { currentUserId } = useAuthStore();

  const { mutate: startOrGetConversation } = useStartOrGetConversation();

  return (
    <View style={styles.container}>
      <PersonSearch
        onSelect={async (profile) => {
          startOrGetConversation(
            {
              userId: profile.user_id,
            },
            {
              onSuccess: (conversation) => {
                router.navigate(`/inbox/all/${conversation._id}`);
              },
            },
          );
        }}
        hiddenIds={currentUserId ? [currentUserId] : []}
      />
    </View>
  );
}

const createStyles = ({ isMobile, isTablet }: WithResponsive) =>
  StyleSheet.create({
    container: {
      flex: 1,
      padding: isMobile ? 12 : isTablet ? 16 : 20,
    },
  });

export default withAuthGate(NewMessageScreen);
